import { Icon } from "../Icon.js";
import filter_default from "../static/filter.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconFilter.tsx
/* istanbul ignore file -- @preserve */
const IconFilter = ({ color, height, style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: filter_default,
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconFilter };